<template>
  <div class="pc-note__sidebar-tools">
    <icon-list-ul v-if="hasNote" :class="{static: active === 'outline', current: active === 'outline'}" title="笔记大纲" @click="changeHandler('outline')"/>
    <icon-folder-tree v-if="hasNotebook" :class="{static: active === 'catalog', current: active === 'catalog'}" title="笔记本目录" @click="changeHandler('catalog')"/>
    <icon-layer-group :class="{static: active === 'opened', current: active === 'opened'}" title="已打开" @click="changeHandler('opened')"/>
    <icon-file-alt v-if="hasNote" :class="{static: active === 'note_details', current: active === 'note_details'}" title="笔记详情" @click="changeHandler('note_details')"/>
    <icon-book v-if="hasNotebook" :class="{static: active === 'notebook_details', current: active === 'notebook_details'}" title="笔记本详情" @click="changeHandler('notebook_details')"/>
  </div>
</template>

<script>
import IconListUl from '@/components/icon/ListUl.vue'
import IconLayerGroup from '@/components/icon/LayerGroup.vue'
import IconFolderTree from '@/components/icon/FolderTree.vue'
import IconBook from '@/components/icon/Book.vue'
import IconFileAlt from '@/components/icon/FileAlt.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    IconListUl,
    IconLayerGroup,
    IconFolderTree,
    IconBook,
    IconFileAlt
  },
  computed: {
    ...mapGetters({
      active: 'workbench/current/sidebarActive'
    }),
    hasNote () {
      return this.$route.params.noteId !== undefined
    },
    hasNotebook () {
      return this.$route.params.notebookId !== undefined
    }
  },
  methods: {
    ...mapMutations({
      setSidebarActive: 'workbench/current/SET_SIDEBAR_ACTIVE'
    }),
    changeHandler (active) {
      this.setSidebarActive(active)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-note__sidebar-tools {
  height: 3rem;
  min-height: 3rem;
  border-top: 1px solid $border-color-light;
  position: sticky;
  bottom: 0;
  background: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: $color-b3;
  justify-content: space-around;

  .pc-icon {
    width: 2.4rem;
    height: 2.4rem;
    margin-left: .5rem;
  }

  .pc-icon.current {
    color: $color-special;
  }
}
</style>
